import {
  SetMutedAPI,
  EndCallAPI,
  EditCallNameAPI,
  SET_MUTED,
  END_CALL,
  EDIT_CALL_NAME,
  Exceptions,
} from '@weblite-wapps/protocol'
import { showCallEndedSnackbar } from '$comp/snackbars'
import { callService, callStorage, resetCallAndShowNPS } from '$logic/call'
import { wappSubscription } from '../helper/subscription-handler'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication'

wappSubscription.subscribe<SetMutedAPI>(SET_MUTED, ({ muted }) => {
  callStorage.set({ muted })
  return { status: 'ok' }
})

wappSubscription.subscribe<EditCallNameAPI>(
  EDIT_CALL_NAME,
  async ({ name }) => {
    if (!name) return { errorCode: Exceptions.FAILED }

    try {
      await callService.editCallName(name)
    } catch (err) {
      return { errorCode: Exceptions.FAILED }
    }

    return { status: 'ok' }
  },
)

wappSubscription.subscribe<EndCallAPI>(END_CALL, async payload => {
  sendEventToTwa(TWA_EVENTS.END_ONGOING_CALL)
  const { reason, reasonType } = payload ?? {}

  await resetCallAndShowNPS(undefined, false)

  if (reason) showCallEndedSnackbar(reason, reasonType)
  return { status: 'ok' }
})
